import { createFileRoute } from "@tanstack/react-router";

import NotFoundPage from "@/components/NotFoundPage";
import { signalNotFound } from "@/routing/notFoundSignal";

/**
 * A bare `/$planId` URL names no page — only the deeper `/$planId/*` routes
 * do. With `$planId.tsx` present as a layout, a single unknown segment
 * (`/anything`) matches here instead of falling through to the `$` catch-all,
 * so this index mirrors the catch-all exactly: the 404 page with a real 404
 * response status.
 */
export const Route = createFileRoute("/_app/_dashboard/$planId/")({
  beforeLoad: () => {
    signalNotFound();
  },
  component: NotFoundPage,
});
